import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { actions } from "../../../../redux/modules/producto/producto";
import { tableOptions } from "Utils/tableOptions";


class ProductoPrevisualizar extends Component {

    state = {
        datos: [],
        total: 0,
        correctos: 0,
        errores: 0,
        cargando: true
    };

    

    componentDidMount() {
        const { location, preview_productos } = this.props;
        const archivo = location.state ? location.state.archivoOriginal : null;

        if (!archivo) {
            Swal.fire("Error", "No se encontró el archivo", "error");
            return;
        }

        const formData = new FormData();
        formData.append("file", archivo);

        preview_productos(formData)
            .then((res) => {

                const productos = res.productos || [];

                productos.sort((a, b) => {
                    const aError = a.errores && a.errores.length > 0;
                    const bError = b.errores && b.errores.length > 0;

                    if (aError === bError) return 0;
                    return aError ? -1 : 1;
                });

                const conErrores = productos.filter(p => p.errores && p.errores.length > 0).length;
                const correctos = productos.length - conErrores;

               

                this.setState({
                    datos: productos,
                    total: productos.length,
                    correctos: correctos,
                    errores: conErrores,
                    cargando: false
                });

            })
            .catch(() => {
                Swal.fire("Error","No se pudo validar el archivo","error");
            });
    }

    handleFinalizar = () => {
    const { correctos, errores } = this.state;
    const { location, importar_productos, history } = this.props;
    const archivo = location.state ? location.state.archivoOriginal : null;

    if (!archivo) {
        Swal.fire("Error", "No se encontró el archivo original", "error");
        return;
    }

    // Preparamos el mensaje con el estilo que pediste
    let mensajeConfirmacion = `<p>Estás a punto de importar <b>${correctos}</b> productos a tu tienda.</p>`;
    if (errores > 0) {
        mensajeConfirmacion += `
            <p style="color: red; margin-top: 10px;">
                <i class="fa fa-exclamation-triangle"></i> 
                Hay <b>${errores}</b> productos que no se podrán importar por diferentes errores.
            </p>`;
    }
    mensajeConfirmacion += `<p style="margin-top: 15px;">¿Deseas continuar?</p>`;

    // PRIMER MODAL: Confirmación
    Swal.fire({
        title: 'Confirmar Importación',
        html: mensajeConfirmacion,
        icon: errores > 0 ? 'warning' : 'question',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#f1c40f',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
    }).then((result) => {
        // Validamos result.value para máxima compatibilidad con versiones viejas y nuevas
        if (result.value || result.isConfirmed) {
            
            // SEGUNDO MODAL: El que ya viste que funciona (Loading)
            Swal.fire({
                title: 'Importando productos',
                html: `
                    <p>Estamos procesando el archivo Excel.</p>
                    <p style="margin-top:10px;"><strong>Esto puede tardar unos segundos.</strong></p>
                `,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                onBeforeOpen: () => { // Usamos onBeforeOpen por si tu versión es v8 o inferior
                    Swal.showLoading();
                },
                didOpen: () => { // O didOpen si es v9+
                    Swal.showLoading();
                }
            });

            const formData = new FormData();
            formData.append('file', archivo); 

            importar_productos(formData)
                .then(() => {
                    // Si todo sale bien, vamos a la lista
                    history.push("/productos");
                })
                .catch((error) => {
                    Swal.close();
                    let mensaje = "Ocurrió un error al importar el archivo.";
                    if (error.response && error.response.data && error.response.data.error) {
                        mensaje = error.response.data.error;
                    }
                    Swal.fire("Error", mensaje, "error");
                });
        }
    });
};

    render() {

        const { datos, total, correctos, errores, cargando } = this.state;

        var location = this.props.location || {};
        var state = location.state || {};

        const estilos = {
            tablaWrapper: {
                overflowX: "auto", // scroll horizontal si no cabe
                width: "100%"
            },
            tabla: {
                tableLayout: "auto"
            },
            celda: {
                whiteSpace: "normal",
                wordBreak: "break-word"
            }
        };

        const options = _.cloneDeep(tableOptions); 
    
        // Puedes agregar o sobrescribir algo específico si quieres
        options.noDataText = "No hay productos";

        return (
            <div className="container-fluid">


                <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                    <div className="card-header bg-white d-flex justify-content-between align-items-center">
                        <div>
                            <h3 style={{ fontWeight: 'bold' }}>Previsualización</h3>
                            <p className="text-muted small">Si todo se encuentra bien, haz click en finalizar.</p>
                            <p className="text-muted small">Al hacer clic en Finalizar, los productos se crearán en el catálogo general y las existencias se asignarán a la sucursal seleccionada arriba.</p>
                        </div>
                        <div className="d-flex">
                            <button className="btn btn-light mr-2" onClick={() => this.props.history.goBack()}>Cancelar</button>
                            <button
                            className="btn btn-warning"
                            style={{ backgroundColor: '#f1c40f', fontWeight: 'bold', color:'black' }}
                            onClick={this.handleFinalizar}
                            disabled={correctos === 0}
                            >
                            Finalizar
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">

                            <div className="col-md-4">
                                <div className="alert alert-info">
                                    <b>Total cargados:</b> {total}
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="alert alert-success">
                                    <b>Correctos:</b> {correctos}
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="alert alert-danger">
                                    <b>Con errores:</b> {errores}
                                </div>
                            </div>

                        </div>
                        <div style={estilos.tablaWrapper}>
                            <BootstrapTable
                                data={datos}
                                striped
                                hover
                                pagination
                                options={options}
                                tableStyle={estilos.tabla}
                                tdStyle={estilos.celda}
                                thStyle={estilos.celda}
                            >

                            <TableHeaderColumn
                                dataField="fila"
                                width="70"
                            >
                                Fila excel
                            </TableHeaderColumn>

                            <TableHeaderColumn isKey dataField="codigo" tdStyle={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: "200px" }}>
                            Código de barras
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="nombre" tdStyle={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: "200px" }}>
                            Nombre
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="marca">
                            Marca
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                dataField="descripcion"
                                tdStyle={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: "200px" }}
                            >
                                Descripción
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="precio">
                            Precio
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="precio2">
                            Precio 2
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="precio3">
                            Precio 3
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="precio4">
                            Precio 4
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="precio5">
                            Precio 5
                            </TableHeaderColumn>

                            <TableHeaderColumn 
                                dataField="familia" 
                                tdStyle={{ whiteSpace: "normal" }}
                                dataFormat={(cell) => {
                                    // Si el backend mandara un objeto: cell.nombre
                                    // Como mandamos el texto directo del Excel:
                                    return cell || <span className="text-muted">Sin Familia</span>;
                                }}
                            >
                                Familia
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="existencias">
                            Existencias
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField="costo_compra">
                            Precio compra
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                dataField="errores"
                                width="250px" // <--- Agregamos un ancho fijo
                                dataFormat={(cell) => {
                                    if (!cell || cell.length === 0) {
                                        return <span className="text-success" style={{ fontWeight: 'bold' }}>Correcto</span>;
                                    }

                                    return (
                                        <ul style={{ 
                                            color: "red", 
                                            margin: 0, 
                                            paddingLeft: "15px", // Reducimos el sangrado
                                            fontSize: "12px",    // Fuente ligeramente más pequeña para que quepa el texto
                                            whiteSpace: "normal" // Forzamos a que el texto haga salto de línea
                                        }}>
                                            {cell.map((e, i) => <li key={i}>{e}</li>)}
                                        </ul>
                                    );
                                }}
                            >
                                Estado
                            </TableHeaderColumn>

                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const md2p = {
    ...actions,
};


export default connect(null, md2p)(ProductoPrevisualizar);